import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild{
  constructor(
    private oidcSecurityService: OidcSecurityService,
  ) {}

  canActivate(): Observable<boolean> {
      return this.oidcSecurityService.checkAuthIncludingServer(environment.authConfig).pipe(
        tap(({ isAuthenticated }) => {
          if (!isAuthenticated) {
            // Keine gültige Session → starte Login
            this.oidcSecurityService.authorize(environment.authConfig);
          } 
        }),
        map(({ isAuthenticated }) => isAuthenticated),
        take(1)
      ); 
  }

  canActivateChild(
  ) {
    return this.canActivate();
  }
}